import * as request from '@eika-infrastruktur/request';
import { Dispatch } from 'redux';
import { SERVICE_PATH } from './index';
import { BankIdInfo } from '../generated-types';

import MockBankIdInfo from '../static/data/MockBankIdInfo';

const SET_BANKID_INFO = 'SET_BANKID_INFO';

/******************************************************************************
******************************************************************************/
export const getBankIdInfo = () => async (dispatch: Dispatch) => {
    let result: any = null;
    const mockIfError = false;

    const url = `${SERVICE_PATH}/overview/info`;

    try {
        result = await request.post(url).then((response: any) => {
            return response || null;
        }).catch(() =>  null );
    } catch (error) {
        result = null;
    }

    // kiet test
    if ( !result && mockIfError ) { result = MockBankIdInfo; }

    dispatch({ type: SET_BANKID_INFO, result });
};

export const setBankIdInfo = ( result?: null | BankIdInfo ) => async (dispatch: Dispatch) => {
    dispatch({ type: SET_BANKID_INFO, result });
};

/******************************************************************************
******************************************************************************/
export interface OverviewReducer {
    bankIdInfo?: null | BankIdInfo;
}

const initialState: OverviewReducer = {
    bankIdInfo: undefined,
};

//@ts-ignore
export default (state = initialState, action: any = {}) => {
    switch (action.type) {
        case SET_BANKID_INFO:
            return {...state, bankIdInfo: action.result };
        default:
            return state;
    }
};
